import { Thasadith } from 'next/font/google';
import { config } from './config';

export async function trackChatQuestion(productLink, clickedQuestion, questionsClicked, sessionId, customerId, website, productNumber) {
    const url = `${config.BASE_URL}/track/chat`;
    const clickOrder = questionsClicked.length - 1;
    const userAgent = navigator.userAgent;
    const body = {
        q_id: clickedQuestion.id,
        q: clickedQuestion.question,
        a: clickedQuestion.answer,
        se_id: sessionId,
        co: clickOrder,
        url: productLink,
        ua: userAgent,
        site: website,
        c_id: customerId,
        p_n: productNumber ? productNumber : null,
    }
    const response = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(body)
    });
    if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
    }
    const data = await response.json();
    return data;
}

// class TrackChatQuestionRequest(BaseModel):
//     q_id: str = Field(..., description="The question id")
//     q: str = Field(..., description="The question")
//     a: str = Field(..., description="The answer to the question")
//     se_id: str = Field(..., description="The session id")
//     co: int = Field(..., description="The click order of the question")
//     url: str = Field(..., description="The URL of the product")
//     p_id: Optional[str] = Field(None, description="The product id")
//     ua: str = Field(..., description="The user agent of the browser")
//     site: str = Field(..., description="The customer's site")
//     c_id: str = Field(..., description="Client id")